import { useMemo } from "react"
import { Block, BlockProps, useStyletron } from "@mezo-org/mezo-clay"

import { SIDEBAR_NAVIGATION_WIDTH } from "#/shared/constants"
import { useMobileScreen } from "#/shared/hooks"

export default function InnerContainer({ children, ...props }: BlockProps) {
  const isMobileScreen = useMobileScreen()
  const [css, theme] = useStyletron()

  const padding = useMemo(
    () =>
      isMobileScreen
        ? theme.sizing.scale1000
        : `${theme.sizing.scale800} ${theme.sizing.scale1600}`,

    [isMobileScreen, theme.sizing],
  )

  return (
    <Block
      margin={isMobileScreen ? "0 -40px -64px" : "0 -64px -64px"}
      width={
        isMobileScreen ? "100vw" : `calc(100vw - ${SIDEBAR_NAVIGATION_WIDTH})`
      }
      {...props}
    >
      <Block className={css({ maxWidth: "1260px", padding })}>{children}</Block>
    </Block>
  )
}
